import type { ErrorMessage } from 'root/apps/InventoryCount/contexts/ErrorMessage';

export const ApiErrors = {
  GENERIC: {
    message: 'Something went wrong. Try again or contact support if the problem persists.',
  },
  UPLOAD_FILE: {
    message:
      'Unable to upload file. Please check your file and try again or contact support if the problem persists.',
  },
  MAPPING_COLUMN: {
    message:
      'Unable to process data. Please check your file and try again or contact support if the problem persists.',
  },
  IMPORT_ERROR: {
    message: 'Unable to import file. Try again or contact Support if the problem persists. ',
  },
};

export const getApiError = (
  method?: 'GENERIC' | 'UPLOAD_FILE' | 'MAPPING_COLUMN' | 'IMPORT_ERROR'
): ErrorMessage => {
  if (method === 'UPLOAD_FILE') {
    return ApiErrors.UPLOAD_FILE;
  }
  if (method === 'MAPPING_COLUMN') {
    return ApiErrors.MAPPING_COLUMN;
  }
  return ApiErrors.GENERIC;
};

export const parseApiErrorLength = (message: string) => {
  return message.length > 200 ? `${message.substring(0, 200)}...` : message;
};
